<template>
  <div
    class="hotSaleCourseBox"
    v-if="courseInfoData.length"
  >
    <div class="hotSaleCourseWarrp">
      <div class="bg"></div>
      <div class="courseHead">
        <h2>热销课程榜单</h2>
        <div
          v-if="showMore"
          class="lookMore"
          @click="lookMoreList"
        >查看更多<img
            src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/home/hotsalelookmore.png"
            alt=""
          ></div>
      </div>
      <ul class="hotSaleCourseMain">
        <li
          v-for="(item, keys) in courseInfoData"
          :key="keys"
          @click="goDateil(item)"
        >
          <div class="hotSalePic"><img
              :src="item.coverMobile"
              alt=""
            ></div>
          <div class="hotSaleName">
            <h3>{{item.name}}</h3>
            <span>{{item.brief}}</span>
            <div class="priceSaleBox">
              <div class="salesVolumeBox">
                {{ item.salesVolume }}人报名
              </div>
              <div class="coursePrice">
                <!-- <del v-if="item.originalPrice">￥{{ item.originalPrice }}</del> -->
                <span
                  class="courseType"
                  v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount"
                >拼团价</span>
                <span
                  v-else-if="item.promotionLabel"
                  class="courseType"
                >{{item.promotionLabel === 1 ? '折后价' : item.promotionLabel === 4 ? '券后价' : '限时价'}}</span>
                <p class="showPic">
                  <template v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount">
                    <b>¥</b>
                    <span>{{ item.productDiscountRespVO.discountMinPrice }}</span>
                  </template>
                  <template v-else>
                    <b v-if="item.sellPrice === 0 && !item.promotionLabel ? false : true">¥</b>
                    <span :class="{ fontSty: item.sellPrice === 0 && !item.promotionLabel }">{{
                item.sellPrice === 0 && !item.promotionLabel ? '限时免费' : item.sellPrice
              }}</span>
                  </template>
                </p>
              </div>

            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { reqCombinationlist } from '@/api/combination';
// eslint-disable-next-line import/no-cycle
import { reqMajorAd, reqProducts } from '@/api/home';
import { gioPlatform } from '@/utils/tools';
// 广告曝光与广告点击
export default {
  data() {
    return {
      courseInfoData: [],
      showMore: true, // 是否显示查看更多
    };
  },
  props: {
    hotSaleId: Number,
    examYear: Number,
  },
  watch:{
    hotSaleId(){
       this.getCourseAd();
    }
  },
  mounted() {
  },
  methods: {
    // 查看更多
    lookMoreList() {
      this.$router.push({
        path: '/hotSaleList',
        query: {
          recommendId: this.hotSaleId,
        },
      });
    },
    goDateil(item) {
      console.log(item, 'item');
      if (item.setType === 1) {
        // 套餐
        this.$router.push({
          path: '/combinationCourse',
          query: {
            combinationId: item.packageId,
          },
        });
      } else {
        this.$router.push({
          path: '/courseDetail',
          query: {
            courseId: item.productId,
          },
        });
      }
      this.gioEvent(item);
    },
    // 查询广告位
    async getCourseAd() {
      const { code, data } = await reqMajorAd(this.hotSaleId);
      if (code === 0 && data?.length) {
        const { recommendContentVOList } = data[0];
        this.getMajorList(recommendContentVOList);
      }
    },
    // 查询课程卡片信息
    async getMajorList(recommendContentVOList) {
      const allProductIds = [];
      const allPackageIds = [];
      (recommendContentVOList || []).forEach((child) => {
        if (child.recommendType === 0) {
          allProductIds.push(child.productId);
        } else {
          allPackageIds.push(child.productId);
        }
      });
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const p1 = allProductIds.length ? reqProducts(allProductIds, endPoint) : {};
      const p2 = allPackageIds.length ? reqCombinationlist(0, endPoint, allPackageIds) : {};

      Promise.all([p1, p2]).then((result) => {
        const res = result[0];
        const res1 = result[1];
        const resCourse = this.resetProductData(res?.data || [], 2);
        const resPackage = this.resetCoursePackage(res1?.data || []);
        const allCourse = [];
        recommendContentVOList.forEach((child) => {
          const findRes = [...resCourse, ...resPackage].find((course) => {
            const id = child.recommendType === 0 ? course.productId : course.packageId;
            return id === child.productId;
          });
          // eslint-disable-next-line no-unused-expressions
          findRes && allCourse.push(findRes);
        });
        this.courseInfoData = allCourse.length > 3 ? allCourse.slice(0, 3) : allCourse;
        this.showMore = allCourse.length > 3;
        if (!this.$root.$data.isApp) {
          // H5中储存数据
          sessionStorage.setItem('HOTSALELIST', JSON.stringify(allCourse));
        }
        // 广告曝光
        this.gioAdShown(this.courseInfoData);
      });
    },
    // 自定义数据格式
    resetProductData(courseList) {
      courseList.forEach((item) => {
        const { productDiscountRespVO, teacherRespVOS } = item;
        Object.assign(item, {
          isArk: 1,
          salesVolume: Number(item.realSales) + Number(item.initialSales),
          courseBeginTime: item.startTime, // 开课时间
          isUnionDiscount: productDiscountRespVO?.isUnionDiscount, // 联报
          isCouponDiscount: productDiscountRespVO?.isCouponDiscount, // 优惠券
          teacherRespVOS: teacherRespVOS?.map((teacher) => ({
            teacherHead: teacher.teacherHead ? teacher.teacherHead : '',
            name: teacher.name,
          })),
        });
        if (
          productDiscountRespVO?.isCouponDiscount
          && productDiscountRespVO?.couponDiscount
          && item.sellPrice > 0
          && !productDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: productDiscountRespVO.discountPrice,
          });
        }
        if (productDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: productDiscountRespVO?.promotionLabel,
            originalPrice: (
              Number(productDiscountRespVO.discountMinPrice)
              + Number(productDiscountRespVO.discountAmount)
            ).toFixed(2),
            sellPrice: productDiscountRespVO.discountMinPrice,
            acvitityShowTime: productDiscountRespVO?.promotionShowTime,
            acvitityStartTime: productDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: productDiscountRespVO?.promotionEndTime,
          });
        }
      });
      return courseList;
    },
    // 套餐卡片
    resetCoursePackage(majorCourseList) {
      majorCourseList.forEach((item) => {
        const { packageDiscountRespVO } = item;
        Object.assign(item, {
          isArk: 1,
          setType: 1,
          salesVolume: Number(item.actualSales) + Number(item.initialSales),
          isCouponDiscount: packageDiscountRespVO?.isCouponDiscount, // 优惠券
        });
        if (
          packageDiscountRespVO?.isCouponDiscount
          && item.sellPrice > 0
          && !packageDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
          });
        }
        if (packageDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: packageDiscountRespVO?.promotionLabel,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
            acvitityShowTime: packageDiscountRespVO?.promotionShowTime,
            acvitityStartTime: packageDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: packageDiscountRespVO?.promotionEndTime,
          });
        }
      });
      return majorCourseList;
    },
    gioEvent(courseInfoData) {
      const { name } = courseInfoData;
      // 点击广告
      // eslint-disable-next-line
      gio('track', 'adClick_event', {
        adPosition_var: `${this.examYear}考研-首页-热销课程`, // 广告位置
        pageName_var: '首页', // 页面名称
        adSequence_var: null, // 广告序号
        adId_var: courseInfoData?.setType === 1 ? courseInfoData.packageId : courseInfoData.productId,
        adName_var: name, // 广告名称
        linesBusiness_var: '考研', // 业务线
        jumpType_var: courseInfoData?.setType === 1 ? '套餐' : '产品', // 跳转类型
        platform_var: gioPlatform(),
      });
    },
    // 广告曝光gio
    gioAdShown(courseInfoData) {
      const jumpTypeList = []; const adNameList = []; const
        adIdList = [];
      // eslint-disable-next-line no-unused-expressions
      courseInfoData?.forEach((element) => {
        // eslint-disable-next-line
        const jumpType = element?.setType === 1 ? '套餐' : '产品'
        const ids = element?.setType === 1 ? element.packageId : element.productId;
        jumpTypeList.push(jumpType);
        adNameList.push(element.name);
        adIdList.push(ids);
      });

      // eslint-disable-next-line no-undef
      gio('track', 'adShown_event', {
        adPosition_var: `${this.examYear}考研-首页-热销课程`, // 广告位置
        pageName_var: '首页', // 页面名称
        adSequence_var: null, // 广告序号
        adId_var: adIdList.toString(), // 广告ID
        adName_var: adNameList.toString(), // 广告名称
        linesBusiness_var: '考研', // 业务线
        jumpType_var: jumpTypeList.toString(), // 跳转类型
        platform_var: gioPlatform(),
      });
    },

  },

};
</script>
<style lang="scss" scoped>
.hotSaleCourseBox {
  box-sizing: border-box;
  width: 100%;
  padding-top: 18px;
  background: #f8f8f8;
  .hotSaleCourseWarrp {
    box-sizing: border-box;
    padding-bottom: 5px;
    background: linear-gradient(360deg, #fff 0%, #fcede6 100%);
    .bg {
      width: 100%;
      height: 200px;
      background: url(https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/home/hotsaleBg.png)
        no-repeat;
      background-size: 100% 100%;
    }
    .courseHead {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 670px;
      margin: 0 auto;
      margin-top: -168px;
      h2 {
        color: #111;
        font-weight: 500;
        font-size: 32px;
        line-height: 44px;
      }
      .lookMore {
        color: #999;
        font-weight: 400;
        font-size: 20px;
        line-height: 28px;
        img {
          width: 20px;
          height: 20px;
        }
      }
    }
    .hotSaleCourseMain {
      width: 670px;
      margin: 32px auto 0 auto;
      padding: 0 24px;
      background: #fff;
      border-radius: 16px;
      li {
        display: flex;
        align-items: flex-start;
        padding: 28px 0;
        border-bottom: 2px solid #f5f5f5;
        &:nth-child(1) .hotSalePic::before {
          background: url(https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/home/hotOne.png)
            no-repeat;
          background-size: 100% 100%;
        }
        &:nth-child(2) .hotSalePic::before {
          background: url(https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/home/hotTwo.png)
            no-repeat;
          background-size: 100% 100%;
        }
        &:nth-child(3) .hotSalePic::before {
          background: url(https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/home/hotThree.png)
            no-repeat;
          background-size: 100% 100%;
        }
        &:last-child {
          border-bottom: none;
        }
        .hotSalePic {
          position: relative;
          margin-right: 24px;
          &::before {
            position: absolute;
            top: 0;
            right: -1px;
            width: 62px;
            height: 36px;
            content: '';
          }

          img {
            width: 180px;
            height: 130px;
            border-radius: 16px;
          }
        }
        .hotSaleName {
          width: 418px;
          > h3 {
            overflow: hidden;
            color: #333;
            font-weight: 500;
            font-size: 32px;
            line-height: 36px;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          > span {
            display: block;
            height: 36px;
            margin: 10px 0 14px 0;
            overflow: hidden;
            color: #333;
            font-weight: 400;
            font-size: 24px;
            line-height: 36px;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .priceSaleBox {
            display: flex;
            align-items: baseline;
            justify-content: space-between;
            .salesVolumeBox {
              color: #999;
              font-weight: 400;
              font-size: 20px;
              line-height: 28px;
            }
            .coursePrice {
              display: flex;
              align-items: baseline;
              // del {
              //   color: #ff3938;
              //   font-size: 30px;
              // }
              .courseType {
                color: #ff3938;
                font-weight: 500;
                font-size: 20px;
              }
              .showPic {
                margin-left: 6px;
                font-weight: 400;
                font-size: 30px;
                text-align: center;
                b {
                  margin: 0 4px;
                  color: #ff3938;
                  font-size: 20px;
                }
                span {
                  color: #ff3938;
                  font-weight: 400;
                  font-size: 30px;
                }
                .fontSty {
                  font-size: 30px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
